import {Injectable, ClassProvider} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpHeaders, HTTP_INTERCEPTORS} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CookieService} from '@ui-app/services/cookie.service';

@Injectable()
export class HttpHeaderInterceptor implements HttpInterceptor {
    constructor(private cookieService: CookieService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const userAlias: string = this.cookieService.get('UserAlias');

        let requestHeaders: HttpHeaders = req.headers
            .set('Browser-Timezone-Offset', new Date().getTimezoneOffset().toString());

        if (userAlias) {
            requestHeaders = requestHeaders.set('UserAlias', userAlias);

            /**
             * @todo
             * AWS S3 failed with authorization header
             */
            if (req.url.includes('dbadge-photostore-s3')) {
                requestHeaders = requestHeaders.delete('authorization');
            }
        }

        const clonedRequest = req.clone({headers: requestHeaders});

        return next.handle(clonedRequest);
    }
}

export const HTTP_HEADER_INTERCEPTOR_PROVIDER: ClassProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpHeaderInterceptor,
    multi: true
};
